import { api, CertificationTypeEnum, MainCentreAssignmentValidationResult } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

export const centreValidationApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    validateMainCentreAssignment: builder.query<
      MainCentreAssignmentValidationResult,
      { examinerId: number; certificationType: CertificationTypeEnum }
    >({
      query: ({ examinerId, certificationType }) =>
        api.examinerCentre.validateMainCentreAssignmentForCertificationType({
          examinerId,
          certificationType,
        }),
    }),
  }),
});

export const { useValidateMainCentreAssignmentQuery } = centreValidationApi;
